export enum ContactTypeEnum {
  Email,
  PhoneNumber,
  Website,
  Fax,
  Other
}
